"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CoreError = /** @class */ (function (_super) {
    __extends(CoreError, _super);
    function CoreError(params) {
        if (params === void 0) { params = {}; }
        var _this = this;
        var _a = params.message, message = _a === void 0 ? 'Internal Server Error' : _a, code = params.code, _b = params.type, type = _b === void 0 ? 'core_error' : _b, details = params.details, data = params.data, field = params.field;
        _this = _super.call(this, typeof params === 'string' ? params : message) || this;
        _this.code = code;
        _this.type = type;
        _this.details = details;
        _this.data = data;
        _this.field = field;
        _this.name = 'CoreError';
        return _this;
    }
    return CoreError;
}(Error));
exports.CoreError = CoreError;
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(params) {
        var _this = _super.call(this, params) || this;
        _this.name = 'ValidationError';
        return _this;
    }
    return ValidationError;
}(CoreError));
exports.ValidationError = ValidationError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTtJQUErQiw2QkFBSztJQU9sQyxtQkFBYSxNQUFnQjtRQUFoQix1QkFBQSxFQUFBLFdBQWdCO1FBQTdCLGlCQWdCQztRQWRHLElBQUEsbUJBQWlDLEVBQWpDLHNEQUFpQyxFQUNqQyxrQkFBSSxFQUNKLGdCQUFtQixFQUFuQix3Q0FBbUIsRUFDbkIsd0JBQU8sRUFDUCxrQkFBSSxFQUNKLG9CQUFLLENBQ0k7UUFDWCxRQUFBLGtCQUFNLE9BQU8sTUFBTSxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsU0FBQTtRQUNwRCxLQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUNqQixLQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUNqQixLQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixLQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUNqQixLQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztRQUNuQixLQUFJLENBQUMsSUFBSSxHQUFHLFdBQVcsQ0FBQzs7SUFDMUIsQ0FBQztJQUNILGdCQUFDO0FBQUQsQ0FBQyxBQXhCRCxDQUErQixLQUFLLEdBd0JuQztBQXhCWSw4QkFBUztBQXlCdEI7SUFBcUMsbUNBQVM7SUFDNUMseUJBQWEsTUFBVztRQUF4QixZQUNFLGtCQUFNLE1BQU0sQ0FBQyxTQUVkO1FBREMsS0FBSSxDQUFDLElBQUksR0FBRyxpQkFBaUIsQ0FBQzs7SUFDaEMsQ0FBQztJQUNILHNCQUFDO0FBQUQsQ0FBQyxBQUxELENBQXFDLFNBQVMsR0FLN0M7QUFMWSwwQ0FBZSJ9


//////////////////
// WEBPACK FOOTER
// ../@core/dist/errors.js
// module id = 234
// module chunks = 0